import React from "react";
import { LegalLayout } from "../components/LegalLayout";

const Accessibility = () => (
  <LegalLayout
    overline="Legal"
    title="Accessibility Statement"
    lastUpdated="December 2025"
  >
    <h2>Our commitment</h2>
    <p>
      Lawfields Solicitors is committed to making our website accessible in
      accordance with the Public Sector Bodies (Websites and Mobile Applications)
      (No. 2) Accessibility Regulations 2018. We aim to meet the Web Content
      Accessibility Guidelines (WCAG) 2.2 at Level AA.
    </p>

    <h2>What we do</h2>
    <ul>
      <li>Use sufficient colour contrast (4.5:1 minimum) for body text.</li>
      <li>Ensure all interactive elements are keyboard-operable.</li>
      <li>Provide meaningful alt text for informative images.</li>
      <li>Use semantic HTML structure (headings, lists, landmarks).</li>
      <li>Support browser text resizing up to 200% without loss of content.</li>
      <li>Respect the user&apos;s reduced-motion preference.</li>
    </ul>

    <h2>Known limitations</h2>
    <p>
      We are aware of the following accessibility gaps and are working to
      address them:
    </p>
    <ul>
      <li>The Google Maps embed in the Contact section is provided by a third party and may not be fully keyboard-navigable.</li>
      <li>Some decorative grain textures may render unevenly in older browsers.</li>
    </ul>

    <h2>Assistive technology tested</h2>
    <p>
      The website has been tested with current versions of Chrome, Safari and
      Firefox using the built-in VoiceOver (macOS / iOS) and TalkBack (Android)
      screen readers.
    </p>

    <h2>Alternative formats</h2>
    <p>
      If you need information from this website in a different format — for
      example, large print, easy read, audio recording, or braille — please
      contact us:
    </p>
    <ul>
      <li>Email: <a href="mailto:info@lawfields.co.uk">info@lawfields.co.uk</a></li>
      <li>Telephone: 020 8574 0800</li>
      <li>Post: 47 North Road, Southall, Middlesex UB1 2JL</li>
    </ul>
    <p>We will consider your request and respond within 5 working days.</p>

    <h2>Reporting accessibility problems</h2>
    <p>
      If you find an accessibility issue not listed above, please email
      <a href="mailto:info@lawfields.co.uk"> info@lawfields.co.uk</a> with
      details of the page and the difficulty encountered. We aim to acknowledge
      reports within 2 working days.
    </p>

    <h2>Enforcement procedure</h2>
    <p>
      The Equality and Human Rights Commission (EHRC) is responsible for
      enforcing the accessibility regulations. If you are not happy with how we
      respond to your complaint, contact the
      <a href="https://www.equalityadvisoryservice.com/" target="_blank" rel="noreferrer">
        {" "}Equality Advisory and Support Service (EASS)
      </a>.
    </p>
  </LegalLayout>
);

export default Accessibility;
